// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.9998 15.4998C10.9998 14.4516 11.6442 13.9998 11.9998 13.9998C12.3554 13.9998 12.9998 14.4516 12.9998 15.4998C12.9998 16.548 12.3554 16.9998 11.9998 16.9998C11.6442 16.9998 10.9998 16.548 10.9998 15.4998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM10.2327 10.1338L6.76855 8.13379L5.76855 9.86584L9.23266 11.8658L10.2327 10.1338ZM14.7686 11.8658L18.2327 9.86584L17.2327 8.13379L13.7686 10.1338L14.7686 11.8658ZM11.9998 11.9998C10.1463 11.9998 8.99981 13.7866 8.99981 15.4998C8.99981 17.213 10.1463 18.9998 11.9998 18.9998C13.8534 18.9998 14.9998 17.213 14.9998 15.4998C14.9998 13.7866 13.8534 11.9998 11.9998 11.9998Z"}}]};

const Swear2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'swear-2-filled',
    ref,
    icon: element,
  },
));

Swear2FilledIcon.displayName = 'Swear2FilledIcon';

export default Swear2FilledIcon;
